var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.process)?_c('b-card',{staticClass:"p-2"},[_c('Form',{ref:"form",attrs:{"process":_vm.process,"can":_vm.$can(_vm.$acl.action.Create, _vm.$acl.subjects.Processes)},on:{"submit":_vm.submit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }